import styled from "styled-components";
import { Modal } from "antd";

export const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 24px;
    border-radius: 8px;
  }

  .ant-modal-close {
    top: 24px;
    right: 24px;
  }

  .ant-modal {
    width: 750px;
    max-width: 750px;
  }
`;

export const Header = styled.h2`
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 600;
  font-family: "Manrope", sans-serif;
  color: #1a1a1a;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  color: #5A6C87;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 16px;
  border: 1px solid ${(props) => (props.error ? "#ff4d4f" : "#d9d9d9")};
  border-radius: 4px;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  color: #5A6C87;
  outline: none;
  transition: border-color 0.3s;

  &:focus {
    border-color: ${(props) => (props.error ? "#ff4d4f" : "#0C53BB")};
  }

  &::placeholder {
    color: #bfbfbf;
    font-family: "Manrope", sans-serif;
  }
`;

export const UploadAreaLabel = styled.label`
  display: block;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  color: #5A6C87;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const FileUploadArea = styled.div`
  width: 100%;
  min-height: 132px;
  margin-bottom: 16px;

  &[data-has-file="true"] {
    min-height: 56px;
    background-color: transparent;
    border: none;
  }

  border: 1px solid rgba(218, 230, 247, 1);
  border-radius: 4px;
  background-color: rgba(241, 246, 254, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s, background-color 0.3s;

  &:hover {
    border-color: #0C53BB;
    background-color: #DAE6F7;
  }

  &[data-is-drag-active="true"] {
    border: 2px dashed #0C53BB;
    background-color: #DAE6F7;
  }

  .upload-placeholder-text {
    font-family: "Manrope", sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: #5A6C87;
    background: transparent;
    border: none;

    strong {
      font-weight: 700;
      color: #48566B;
    }
  }

  .upload-link {
    color: #0C53BB;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FileUploadInput = styled.input`
  display: none;
`;

export const FileInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: rgba(241, 246, 254, 1);
  border: 1px dashed rgba(104, 148, 214, 1);
  border-radius: 4px;
`;

export const FileName = styled.span`
  flex: 1;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 12px;
  margin-left: 5px;
`;

export const FileActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const PreviewIcon = styled.span`
  cursor: pointer;
  color: #0C53BB;
  display: flex;
  align-items: center;

  &:hover {
    color: #40a9ff;
  }
`;

export const RemoveIcon = styled.span`
  cursor: pointer;
  color: #ff4d4f;
  display: flex;
  align-items: center;

  &:hover {
    color: #ff7875;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    cursor: pointer;
    border: 1px solid #CCD2DD;
    border-radius: 4px;
    accent-color: #0C53BB;
    
    &:checked {
      border-color: #0C53BB;
    }
  }
`;

export const CheckboxLabel = styled.label`
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  color: #5A6C87;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  padding: 8px 24px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  color: #1a1a1a;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    border-color: #40a9ff;
    color: #40a9ff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const UploadButton = styled.button`
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  background-color: #0C53BB;
  color: #fff;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    background-color: #0A4296;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  margin-bottom: 16px;
`;
